import { useTranslate } from "@similarweb/i18n-provider";
import { Add } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import CardsWrapper from "app/pages/sales-intelligence/modules/manage-integrations/components/CardsWrapper/CardsWrapper";
import {
    MY_INTEGRATIONS_EMPTY_STATE_CONNECT_API,
    MY_INTEGRATIONS_EMPTY_STATE_CONNECT_CRM,
    MY_INTEGRATIONS_EMPTY_STATE_CONNECT_WEBHOOK,
    MY_INTEGRATIONS_EMPTY_STATE_PLUGIN_MCP,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import { StyledEmptyStateCard, StyledEmptyStateContent } from "./styles";

const ADD_ICON_SIZE = 40;

interface IEmptyStateOption {
    id: string;
    labelKey: string;
    onClick: VoidFunction;
}

const MyIntegrationsEmptyState = (): React.ReactElement => {
    const { translate } = useTranslate();

    const options: IEmptyStateOption[] = [
        {
            id: "connect-crm",
            labelKey: MY_INTEGRATIONS_EMPTY_STATE_CONNECT_CRM,
            onClick: () => {
                void siNavigator.goToCrmIntegrationsPage();
            },
        },
        {
            id: "connect-webhook",
            labelKey: MY_INTEGRATIONS_EMPTY_STATE_CONNECT_WEBHOOK,
            onClick: () => {
                void siNavigator.goToAPIsWebhooksPage();
            },
        },
        {
            id: "plugin-mcp",
            labelKey: MY_INTEGRATIONS_EMPTY_STATE_PLUGIN_MCP,
            onClick: () => {
                void siNavigator.goToMCPServersPage();
            },
        },
        {
            id: "connect-api",
            labelKey: MY_INTEGRATIONS_EMPTY_STATE_CONNECT_API,
            onClick: () => {
                void siNavigator.goToAPIsWebhooksPage();
            },
        },
    ];

    return (
        <CardsWrapper>
            {options.map((option) => (
                <StyledEmptyStateCard
                    key={option.id}
                    onClick={option.onClick}
                    data-automation={`my-integrations-empty-state-${option.id}`}
                >
                    <StyledEmptyStateContent>
                        <Add
                            size={ADD_ICON_SIZE}
                            color={colorsPalettes.blue[400]}
                        />
                        <Text
                            fontVariant="subtitle1"
                            color={colorsPalettes.blue[400]}
                        >
                            {translate(option.labelKey)}
                        </Text>
                    </StyledEmptyStateContent>
                </StyledEmptyStateCard>
            ))}
        </CardsWrapper>
    );
};

export default MyIntegrationsEmptyState;
